export const METRICS = {
  chillHours: {
    key: "chillHours",
    label: "Chill Hours",
    short: "Chill Hours",
    unit: "hrs",
    decimals: 0,
    detail: "32–45°F",
    model: "Hours between 32°F and 45°F",
    seasonStart: "November 1",
    tooltip:
      "Each hour the air temperature sits between 32°F and 45°F counts as one chill hour. Fruit and nut trees need enough winter chill to break dormancy evenly in spring.",
  },
  chillPortions: {
    key: "chillPortions",
    label: "Chill Portions",
    short: "Chill Portions",
    unit: "CP",
    decimals: 1,
    detail: "Dynamic Model",
    model: "Dynamic Model",
    seasonStart: "November 1",
    tooltip:
      "The Dynamic Model counts chill in 'portions'. It accounts for warm spells that can cancel recent chill, which often makes it a better fit for California's mild winters.",
  },
  gdd: {
    key: "gdd",
    label: "Growing Degree Days",
    short: "GDD",
    unit: "GDD",
    decimals: 0,
    detail: "Base 50°F",
    model: "Base 50°F",
    seasonStart: "January 1",
    tooltip:
      "Growing degree days measure heat accumulation: how far each day's temperature rises above 50°F. More GDD means faster crop and pest development.",
  },
};

export const METRIC_OPTIONS = [
  { value: "chillHours", label: "Chill Hours" },
  { value: "chillPortions", label: "Chill Portions" },
  { value: "gdd", label: "GDD" },
];
